import { Grid, Typography } from '@mui/material';
import { RootStateType } from '@Store';
import React from 'react';
import { useSelector } from 'react-redux';

function ChargeTitle() {
  const shipmentById = useSelector((state: RootStateType) => state.adminShipment.shipmentById);
  const { sellingPricing } = shipmentById || {};

  return (
    <Grid container justifyContent={'space-between'}>
      <Typography className="md-text font-semibold">Payment</Typography>
      <Typography color="primary" className="md-text font-semibold">
        Amount {sellingPricing?.currency || ''}
      </Typography>
    </Grid>
  );
}

export default ChargeTitle;
